import DOMPurify from "dompurify";

const search = document.querySelector('.search-field');

if (search) {
    search.addEventListener('input', function (e) {
        purifyTxt(e);
    });
}


function purifyTxt(e) {
    e.target.value = DOMPurify.sanitize(e.target.value);
}